import React from 'react';
import clsx from 'clsx';
import { FingotiButton } from './Button';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

import PagesIcon from '@material-ui/icons/Pages';
import RadioButtonUncheckedOutlinedIcon from '@material-ui/icons/RadioButtonUncheckedOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles(theme => ({

    root: {
        border: '1px solid ' + theme.palette.greyFour.main,
        borderRadius: theme.spacing(1),
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(2) + 'px ' + theme.spacing(3) + 'px ',
        borderBottom: '1px solid ' + theme.palette.greyFour.main,
        background: theme.palette.greyFour.main
    },
    icon: {
        fontSize: '2.25rem',
        fill: theme.palette.greyOne.main,
    },
    headerText: {
        marginLeft: theme.spacing(2),
    },
    title: {
        color: theme.palette.primary.main,
    },
    features: {
        padding: theme.spacing(3),
    },
    featureRow: {
        display: 'flex',
        alignItems: 'center'
    },
    featureText: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    pricing: {
        padding: theme.spacing(3),
    },
    price: {
        color: theme.palette.secondary.main,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-start',
        padding: '0px ' + theme.spacing(2) + 'px'
    },
    button: {
        width: '45%',
    },
    vat: {
        color: theme.palette.greyThree.main,
        marginLeft: theme.spacing(1),
    },
    buttonLeft: {
        justifyContent: 'flex-start !important',
    }

}))

export const PlanCard = ({ isTrial, plan, handleSubscribe, handleLearnMore, business, showSubscribe = true, showLearnMore = true }) => {

    const classes = useStyles();

    let monthCost = business ? parseFloat(plan.pricing.monthly.cost) : parseFloat(plan.pricing.monthly.cost * 1.2);
    let yearCost = business ? parseFloat(plan.pricing.yearly.cost) : parseFloat(plan.pricing.yearly.cost * 1.2);

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <PagesIcon className={classes.icon} />
                <div className={classes.headerText}>
                    <Typography variant='h4' className={classes.title}>{plan.reference}</Typography>
                    <Typography>{plan.name}</Typography>
                </div>
            </div>
            <div className={classes.pricing}>
                <Typography>
                    <span className={classes.price} style={{ fontSize: '2rem' }}>{new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(monthCost)}</span> / month
                    <small className={classes.vat}>{business ? "ex VAT" : "inc VAT"}</small>
                </Typography>
                <Typography>
                    <span className={classes.price}>{new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(yearCost)}</span> / year
                    <small className={classes.vat}>{business ? "ex VAT" : "inc VAT"}</small>
                </Typography>
            </div>
            <div className={clsx(classes.buttons, !showSubscribe && classes.buttonLeft)}>
                {
                    showSubscribe &&
                    <FingotiButton
                        light
                        color={isTrial ? "secondary" : "primary"}
                        onClick={() => handleSubscribe(plan)}
                        className={classes.button}
                    >
                        {isTrial ? "Start Trial" : "Subscribe"}
                    </FingotiButton>
                }
                {
                    showLearnMore &&
                    <FingotiButton
                        light
                        onClick={() => handleLearnMore(plan)}
                        className={classes.button}
                    >
                        Learn more
                    </FingotiButton>
                }
            </div>
            <div className={classes.features}>
                {
                    plan.features.map((feature, i) => {
                        return (
                            <div key={`${i}`} className={classes.featureRow}>
                                <RadioButtonUncheckedOutlinedIcon style={{ fontSize: '0.5rem' }} />
                                <Typography className={classes.featureText}>{feature.value} {feature.text}</Typography>
                                <Tooltip title={feature.tooltip}>
                                    <InfoOutlinedIcon style={{ fontSize: '1rem' }} />
                                </Tooltip>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )

}